module.exports = __webpack_public_path__ + "img/banner transaction_error.9f857ef7.jpg";